import React from "react";

export function calculateDaysBetween(minDate, maxDate) {
  if (!minDate || !maxDate) return 0;
  const diffTime = Math.abs(maxDate - minDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays + 1;
}

export function validateExportParams({ numUsers, minDate, maxDate }) {
  if (!minDate || !maxDate || numUsers === 0) {
    return {
      message: null,
      canChooseConsolidated: false
    };
  }

  const numDays = calculateDaysBetween(minDate, maxDate);

  // Case 1: >= 365 days → 1 file per year per employee
  if (numDays >= 365) {
    return {
      message: (
        <>
          La période sélectionnée étant supérieure à 365 jours, le téléchargement sera divisé 
          en plusieurs fichiers pour des raisons techniques. Vous recevrez <b>un fichier par 
          tranche de 365 jours et par salarié.</b>
        </>
      ),
      canChooseConsolidated: false
    };
  }

  // Case 2: < 365 days AND > 31 days → 1 file per 100 employees per 31-day period
  if (numDays > 31) {
    const message = numUsers > 100 ? (
      <>
        Le nombre de salariés sélectionnés étant supérieur à 100 et la période supérieure à 31 jours, 
        le téléchargement sera divisé en plusieurs fichiers pour des raisons techniques. 
        Vous recevrez <b>un fichier par mois et par tranche de 100 salariés.</b>
      </>
    ) : (
      <>
        La période sélectionnée étant supérieure à 31 jours, 
        le téléchargement sera divisé en plusieurs fichiers pour des raisons techniques. 
        Vous recevrez <b>un fichier par mois.</b>
      </>
    );
    
    return {
      message: message,
      canChooseConsolidated: false
    };
  }

  // Case 3: < 365 days AND < 31 days AND > 100 employees → consolidated file per 100-employee batch
  if (numUsers > 100) {
    return {
      message: (
        <>
          Le nombre de salariés sélectionnés étant supérieur à 100, le téléchargement sera divisé 
          en plusieurs fichiers pour des raisons techniques. Vous recevrez <b>un fichier par 
          tranche de 100 salariés.</b>
        </>
      ),
      canChooseConsolidated: false
    };
  }

  // Case 4: < 365 days AND < 31 days AND < 100 employees → consolidated OR individual file choice
  return {
    message: null,
    canChooseConsolidated: true
  };
}
